module.exports = __webpack_public_path__ + "static/media/checkmark-na.171a88c4.svg";